import React from 'react';
import rtlDetect from 'rtl-detect';
import { HelmetDatoCms } from 'gatsby-source-datocms';
import { useAlternateLocales, useDefaultLocale, useDirection, useLanguage, useLocale } from '../../../context/locale';
import { useBrandImage } from '../../../context/brand';

export const SEO = ({ tags, favicon, schema, isArticle }: any) => {
  const alternateLocales = useAlternateLocales();
  const locale = useLocale();
  const language = useLanguage();
  const defaultLocale = useDefaultLocale();
  const direction = useDirection();
  const currentLocale = alternateLocales ? alternateLocales.find(l => l.locale === locale) : null;
  const icon = useBrandImage("icon");

  const seoTags = (tags ? tags.tags : []).map((t) => {
    if(!isArticle && t.tagName === "meta" && t.attributes.property === "og:type"){
      t.attributes.content = "website"
    }

    return t;
  });
  
  return (
    <HelmetDatoCms seo={{tags:seoTags}} htmlAttributes={{ lang: locale, dir: direction }}>
      <script>
        {`
          if (typeof window !== 'undefined' && typeof window.Proxy === 'undefined') {
            window.location.replace('/${language}/unsupported.html')
          }  
        `}
      </script>


      {alternateLocales && alternateLocales.map((alternate) => (
        <link rel="alternate" href={alternate.url} hrefLang={alternate.locale === defaultLocale ? 'x-default' : alternate.locale} key={alternate.locale} />
      ))}

      <link rel="icon" href={icon.url} type="image/png" />
      
      {currentLocale && <link rel="canonical" href={currentLocale.url} />}
      {currentLocale && <meta property="og:url" content={currentLocale.url} />}
      
      {schema && <script type="application/ld+json">{JSON.stringify(schema)}</script>}
    </HelmetDatoCms>
  );
};